export default __webpack_public_path__ + "static/media/press-van.7933d91f.png";